// /company/{companyId}/programs/{programId}/features/raves
import { convertTimestampToLuxonOrDefaultNow } from "../../utils/convertTimestampToLuxonOrDefaultNow";
export const createRaveConfig = (data) => {
    if (!assertRaveConfig(data, "save")) {
        throw new Error("RaveConfig.save failed");
    }
    return data;
};
export function assertRaveConfig(raveConfig, mode = "load") {
    if (!raveConfig || typeof raveConfig !== "object") {
        throw new Error("RaveConfig must be an object");
    }
    return true;
}
export const createRaveConfigConverter = (convertToFirestoreTimestampOrDefaultServerTime) => ({
    toFirestore(raveConfig) {
        if (!assertRaveConfig(raveConfig, "save")) {
            throw new Error("RaveConfig.save failed");
        }
        const { id, ...raveConfigWithoutId } = raveConfig;
        const data = {
            ...raveConfigWithoutId,
            createdAt: convertToFirestoreTimestampOrDefaultServerTime(raveConfig.createdAt),
            updatedAt: convertToFirestoreTimestampOrDefaultServerTime(raveConfig.updatedAt),
        };
        return data;
    },
    fromFirestore(snapshot, options) {
        const data = snapshot.data(options);
        if (!data)
            throw new Error("Snapshot doesn't contain data");
        const raveConfig = {
            ...data,
            id: snapshot.id,
            createdAt: convertTimestampToLuxonOrDefaultNow(data.createdAt),
            updatedAt: convertTimestampToLuxonOrDefaultNow(data.updatedAt),
        };
        if (!assertRaveConfig(raveConfig)) {
            throw new Error("RaveConfig.load failed");
        }
        return raveConfig;
    },
});
//# sourceMappingURL=RaveConfig.js.map